import { Box, CircularProgressProps, CircularProgress as MuiCircularProgress, Stack, Typography, circularProgressClasses } from "@mui/material";
import type { ReactNode } from "react";


export interface MyCircularProgressProps extends CircularProgressProps {
  label?: ReactNode;
  labelInner?: boolean;
  error?: boolean;
}

export const CircularProgress = (props: MyCircularProgressProps) => {
  const { label, labelInner, error, size = 40, thickness = 4, sx, variant, ...muiProps } = props;

  const renderIndeterminate = () => (
    <Box sx={{ position: 'relative', width: size, height: size }}>
      <MuiCircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: theme.palette.grey[200],
          ...theme.applyStyles('dark', {
            color: theme.palette.grey[800],
          }),
          ...(typeof sx === 'function' ? sx : {}),
        })}
        size={size}
        thickness={thickness}
        value={100}
        {...muiProps}
      />
      <MuiCircularProgress
        variant="indeterminate"
        disableShrink
        sx={(theme) => ({
          color: error ? theme.palette.error.main : theme.palette.primary.main,
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        })}
        size={size}
        thickness={thickness}
        {...muiProps}
      />
      {labelInner && label && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
          }}
        >
          {label}
        </Box>
      )}
    </Box>
  );

  const renderDeterminate = () => (
    <Box sx={{ position: 'relative', width: size, height: size }}>
      <MuiCircularProgress
        variant="determinate"
        sx={(theme) => ({
          color: error ? theme.palette.error.main : theme.palette.primary.main,
          ...(typeof sx === 'function' ? sx : {}),
        })}
        size={size}
        thickness={thickness}
        {...muiProps}
      />
      {labelInner && label && (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
          }}
        >
          {label}
        </Box>
      )}
    </Box>
  );

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      {variant === 'determinate' ? renderDeterminate() : renderIndeterminate()}
      {!labelInner && label && (
        <Typography color="text.secondary">{label}</Typography>
      )}
    </Stack>
  );
};

